<!--
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-20 10:52:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 20:22:24
 * @FilePath: \async-component-ui\packages\components\parse\parse.vue
 * @Description: ~
-->
<template>
  <div class="as-parse" :style="{ width, height }">
    <zm-tooltip
      v-if="tipsContent"
      :content="tipsContent"
      :placement="tipsPlacement"
    >
      <div class="as-parse-body" @click="inputDialoagVisible = true">
        <slot
          ><i
            :class="icon"
            :style="{ fontSize: iconSize + 'px', color: iconColor }"
        /></slot>
      </div>
    </zm-tooltip>
    <div v-else class="as-parse-body" @click="inputDialoagVisible = true">
      <slot
        ><i
          :class="icon"
          :style="{ fontSize: iconSize + 'px', color: iconColor }"
      /></slot>
    </div>
    <zm-dialog
      :visible="inputDialoagVisible"
      append-to-body
      :title="title"
      width="800px"
    >
      <zm-input
        v-model="uploadData"
        type="textarea"
        :autosize="{ minRows: 10, maxRows: 60 }"
        clearable
        label="upload"
        :placeholder="dialogPlaceholder"
        @paste.native.prevent="formatPasteData"
        @change="formatUploadData"
      />
      <div slot="footer">
        <zm-button @click="upload" type="primary">Confirm</zm-button>
        <zm-button @click="cancelUpload">Cancel</zm-button>
      </div>
    </zm-dialog>

    <zm-dialog
      :visible.sync="uploadDataDifftDialoagVisible"
      show-close
      append-to-body
      title="Matched Results"
      width="800px"
    >
      <zm-tabs v-model="activeTab">
        <zm-tab-pane label="success" name="success">
          <ul v-if="uploadSuccess.length">
            <li v-for="(item, i) in uploadSuccess" :key="i">{{ item }}</li>
          </ul>
          <div v-else>all upload fail</div>
        </zm-tab-pane>
        <zm-tab-pane label="fail" name="fail">
          <ul v-if="uploadFail.length">
            <li v-for="(item, i) in uploadFail" :key="i">{{ item }}</li>
          </ul>
          <div v-else>all upload success</div>
        </zm-tab-pane>
      </zm-tabs>
      <div slot="footer">
        <zm-button @click="uploadDataDifftDialoagVisible = false" type="primary"
          >Confirm</zm-button
        >
      </div>
    </zm-dialog>
  </div>
</template>

<script>
export default {
  name: 'AsParse',
  props: {
    uploadFn: {
      type: Function,
      require: true,
      default: (arr) => {
        let res = {}
        res.success = arr
        res.fail = []
        return res
      },
    },
    valuesStr: String,
    icon: {
      type: String,
      default: 'zm-icon-upload-alt',
      validator: function (value) {
        return !value || /^zm-/.test(value)
      },
    },
    iconSize: {
      type: Number,
      default: 16,
    },
    iconColor: {
      type: String,
      default: 'inherit',
    },
    width: {
      type: String,
      default: 'auto',
    },
    height: {
      type: String,
      default: 'auto',
    },
    dialogPlaceholder: {
      type: String,
      default: 'copy or input to parse',
    },
    tips: {
      type: [String, Object],
      default: null,
    },
    title: String,
  },
  computed: {
    tipsContent() {
      if (this.tips) {
        if (typeof this.tips === 'string') {
          return this.tips
        } else if (this.tips.content && typeof this.tips.content === 'string') {
          return this.tips.content
        }
      }
      return null
    },
    tipsPlacement() {
      const PLACEMENTS = [
        'top',
        'top-start',
        'top-end',
        'bottom',
        'bottom-start',
        'bottom-end',
        'left',
        'left-start',
        'left-end',
        'right',
        'right-start',
        'right-end',
      ]
      if (
        typeof this.tips === 'object' &&
        typeof this.tips.placement === 'string' &&
        PLACEMENTS.includes(this.tips.placement)
      ) {
        return this.tips.placement
      }

      return PLACEMENTS[0]
    },
  },
  watch: {
    inputDialoagVisible(v) {
      v && (this.uploadData = this.valuesStr)
    },
  },
  data() {
    return {
      inputDialoagVisible: false,
      uploadDataDifftDialoagVisible: false,
      uploadData: null,
      uploadSuccess: [],
      uploadFail: [],
      activeTab: 'fail',
    }
  },
  methods: {
    cancelUpload() {
      this.inputDialoagVisible = false
      this.uploadData = null
    },
    upload() {
      const formatData = !this.uploadData
        ? []
        : this.uploadData
            .split(/\r|\n/)
            .map((item) => item.trim())
            .filter((item) => item !== '')
      if (formatData.length === 0) {
        this.$message({
          type: 'info',
          message: 'please input data to upload',
        })
        return
      }
      const res = this.uploadFn(formatData)
      this.uploadSuccess = res.success || []
      this.uploadFail = res.fail || []
      this.$message({
        type: 'success',
        message: 'uploaded successfully ',
      })
      this.inputDialoagVisible = false
      this.uploadData = null
      this.activeTab = 'success'
      this.uploadDataDifftDialoagVisible = true
    },
    formatUploadData() {
      this.uploadData = this.uploadData.replaceAll(
        /(\n(?=\n)|\r(?=\r)|\r\n(?=\r\n))/g,
        ''
      )
    },
    formatPasteData(e) {
      const pasteData = e.clipboardData.getData('text')
      const formatData = pasteData.replaceAll(
        /(\n(?=\n)|\r(?=\r)|\r\n(?=\r\n))/g,
        ''
      )
      this.uploadData = this.uploadData
        ? this.uploadData + formatData
        : formatData
    },
  },
}
</script>

<style lang="scss" scoped>
.as-parse {
  display: inline-block;
  .as-parse-body {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  ul {
    list-style: none;

    li {
      font-size: 16px;
    }
  }
}
</style>
